import http from '@/utils/http'

export function getAssessments(params){
    return  http('/assessments',{params})
}

export function putAssessmentsSkip(id,data){
    return  http.post(`/assessments/${id}/skip_request`,data)
}

export function putAssessmentsAnswer(id,data){
    return  http.post(`/assessments/${id}/answer_result`,data)
}